import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import ErrorsMessageDesktop from '@/views/errors/components/ErrorsMessageDesktop.tsx';
import ErrorsMessageMobile from '@/views/errors/components/ErrorsMessageMobile.tsx';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorsView: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const navigate = useNavigate();

  const handleBack = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(RoutesEnum.ROOT);
  };

  return isMobile ? (
    <ErrorsMessageMobile handleBack={handleBack} />
  ) : (
    <ErrorsMessageDesktop handleBack={handleBack} />
  );
};

export default ErrorsView;
